<template>
  <!-- 公示的主要信息 -->
  <div class="publicity-info">
    <div class="item">
      <span>标段编号：</span>
      <span>{{form.bidNum}}</span>
    </div>
    <br />
    <div class="item">
      <span>标段名称：</span>
      <span>{{form.bidName}}</span>
    </div>
    <br />
    <div class="item">
      <span>公示类型：</span>
      <span>{{form.publicityType|filterPublicityType(that)}}</span>
    </div>
    <div class="item">
      <span>是否电子标：</span>
      <span>{{form.electronic|filterElectronicType}}</span>
    </div>
    <!-- 修正类型，只服务于修正公示 -->
    <div class="item" v-if="$route.query.type==5">
      <span>选择修正内容：</span>
      <el-radio-group v-model="form.correctResultType" disabled>
        <el-radio :label="1">修正评标结果</el-radio>
        <el-radio :label="2">修正复核结果公式</el-radio>
        <el-radio :label="3">修正中标成交结果公示</el-radio>
        <el-radio :label="4">修正流标结果</el-radio>
      </el-radio-group>
    </div>
    <!-- 流标类型，只服务于流标公示和修正流标 -->
    <div
      class="item"
      v-if="$route.query.type==4||($route.query.type==5&&$route.query.correctType==2)"
    >
      <span>流标类型：</span>
      <el-radio-group v-model="form.failureBidType" disabled>
        <el-radio :label="1">开标流标</el-radio>
        <el-radio :label="2">评审过程流标</el-radio>
        <el-radio :label="3">报名不足流标</el-radio>
      </el-radio-group>
    </div>
    <br />
    <div class="item">
      <span>招标人：</span>
      <span>{{form.bidderName}}</span>
    </div>
    <div class="item">
      <span>招标人地址：</span>
      <span>{{form.bidderContactAddress}}</span>
    </div>
    <br />
    <div class="item">
      <span>代理机构：</span>
      <span>{{form.agencyCompanyName}}</span>
    </div>
    <div class="item">
      <span>代理机构地址：</span>
      <span>{{form.agencyCompanyAddress}}</span>
    </div>
    <br />
    <div class="item">
      <span>招标代理联系人：</span>
      <span>{{form.agencyContact}}</span>
    </div>
    <div class="item">
      <span>招标代理联系电话：</span>
      <span>{{form.agencyContactPhone}}</span>
    </div>
    <br  v-if="form.superviseName" />
    <div class="item" v-if="form.superviseName">
      <span>监督部门名称：</span>
      <span>{{form.superviseName}}</span>
    </div>
    <div class="item" v-if="form.supervisePhone">
      <span>监督部门联系方式：</span>
      <span>{{form.supervisePhone}}</span>
    </div>
    <br />
    <div class="item">
      <span>开标时间：</span>
      <span>{{form.bidOpenTime|filterTime}}</span>
    </div>
    <div class="item">
      <span>开标地点：</span>
      <span>{{form.bidOpenAddress}}</span>
    </div>
    <br />
    <div class="item" v-if="that.$route.query.isGov == 1">
      <span>招标方式：</span>
      <span>{{form.bidMethod|filterBidMethod}}</span>
    </div>
    <div class="item" v-if="that.$route.query.isGov == 2">
      <span>采购方式：</span>
      <span>{{form.bidMethod|filterBidMethod}}</span>
    </div>

    <br />
    <div class="item">
      <span>评标办法：</span>
      <span>{{form.bidEvaluationMethod}}</span>
    </div>
    <br />
    <template v-if="$route.query.type != 3">
      <div class="item">
        <span>公示开始时间：</span>
        <span>{{form.publicityBeginTime|filterTime}}</span>
      </div>
      <div class="item">
        <span>公示结束时间：</span>
        <span>{{form.publicityEndTime|filterTime}}</span>
      </div>
    </template>
    <!-- 复核结果（只服务于复核结果公示） -->
    <div class="item" v-if="$route.query.type==2">
      <span>复核结果：</span>
      <el-radio-group v-model="form.reviewResult" disabled>
        <el-radio :label="1">维持原结果</el-radio>
        <el-radio :label="2">变更原结果</el-radio>
        <el-radio :label="3">本次流标</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  props: ["form"],
  data(){
    return {
      that: this
    }
  },
  filters: {
    filterElectronicType(val) {
      if (val == 0) return "非电子标";
      if (val == 1) return "电子标";
    },
    // 公示类型（1评标结果公示；2复核结果公示；3中标结果公示；4流标公示；5修正公示）
    filterPublicityType(val, that) {
      if (val == 1) {
        if (that.$route.query.isGov == 2) {
          return "结果公示";
        }
        return "评标结果公示";
      }
      if (val == 2) return "复核结果公示";
      if (val == 3) return "中标结果公示";
      if (val == 4) return "流标公示";
      if (val == 5) return "修正公示";
    },
    // 招标方式(1:公开招标 2:邀请招标 3:竞争性谈判 4:竞争性磋商 5:询价采购 6:单一来源采购)
    filterBidMethod(val) {
      if (val == 1) return "公开招标";
      if (val == 2) return "邀请招标";
      if (val == 3) return "竞争性谈判";
      if (val == 4) return "竞争性磋商";
      if (val == 5) return "询价采购";
      if (val == 6) return "单一来源采购";
      if (val == 7) return "其他";
    },
    // 时间
    filterTime(val) {
      if (val) {
        return moment(val).format("YYYY-MM-DD HH:mm:ss")
      } else {
        return ''
      }
    }
  }
};
</script>

<style lang="less" scoped>
.publicity-info {
  margin-bottom: 20px;
  .item {
    display: inline-block;
    span:first-child {
      color: #000000;
      display: inline-block;
      width: 140px;
    }
    span:last-child {
      display: inline-block;
      width: 380px;
    }
  }
}
</style>
